module.exports = __webpack_public_path__ + "images/category_lp/trading_card/store_images/2@2x_d9be3ec02b400d343e3f8daeaf97b165.png";